import * as Sentry from '@sentry/react';
import React from 'react';

interface Props {
  children: React.ReactNode;
  fallback?: React.ReactElement | Sentry.FallbackRender;
}

const ErrorFallback: React.FC = () => (
  <div
    style={{
      padding: '20px',
      textAlign: 'center',
      backgroundColor: '#f8f9fa',
      border: '1px solid #dee2e6',
      borderRadius: '8px',
      margin: '20px',
    }}
  >
    <h2>Something went wrong</h2>
    <p>We've been notified about this error and will fix it soon.</p>
    <button
      onClick={() => window.location.reload()}
      style={{
        padding: '8px 16px',
        backgroundColor: '#007bff',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
      }}
    >
      Reload Page
    </button>
  </div>
);

const SentryErrorBoundary: React.FC<Props> = ({
  children,
  fallback = <ErrorFallback />,
}) => {
  return (
    <Sentry.ErrorBoundary fallback={fallback} showDialog>
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default SentryErrorBoundary;
